/**
 * Catálogo fixo do cardápio (Galeria/Underline) usado no autocomplete de promoções.
 * `kind` separa o que pode entrar em DOBRADAS/BEBIDAS (drink) e PETISCOS + BURGERS (food).
 */
export type MenuKind = 'drink' | 'food';

export interface MenuItem {
  name: string;
  group: string;
  kind: MenuKind;
  /** Termos extras de busca (apelidos usados no dia a dia). */
  alias?: string;
}

export const MENU_ITEMS: MenuItem[] = [
  // Cervejas e ice
  // Genérico: entra na promoção sem marca definida — a do dia depende do estoque.
  {
    name: 'Cerveja 600ml',
    group: 'Cervejas e Ice',
    kind: 'drink',
    alias: 'cerveja garrafa litrao 600 sem marca',
  },
  { name: 'Bohemia', group: 'Cervejas e Ice', kind: 'drink', alias: 'cerveja' },
  { name: 'Brahma Duplo Malte', group: 'Cervejas e Ice', kind: 'drink', alias: 'cerveja' },
  { name: 'Budweiser', group: 'Cervejas e Ice', kind: 'drink', alias: 'cerveja bud' },
  { name: 'Antarctica Original', group: 'Cervejas e Ice', kind: 'drink', alias: 'cerveja' },
  { name: 'Spaten', group: 'Cervejas e Ice', kind: 'drink', alias: 'cerveja' },
  { name: 'Stella', group: 'Cervejas e Ice', kind: 'drink', alias: 'cerveja artois' },
  { name: 'Ice Long Neck', group: 'Cervejas e Ice', kind: 'drink' },
  { name: 'Budweiser Long Neck', group: 'Cervejas e Ice', kind: 'drink', alias: 'bud' },
  { name: 'Spaten Long Neck', group: 'Cervejas e Ice', kind: 'drink' },
  { name: 'Michelob Long Neck', group: 'Cervejas e Ice', kind: 'drink', alias: 'ultra' },
  { name: 'Stella Long Neck', group: 'Cervejas e Ice', kind: 'drink', alias: 'artois' },
  { name: 'Stella P. Gold Long Neck', group: 'Cervejas e Ice', kind: 'drink', alias: 'pure gold' },

  // Beats
  // Genérico: entra na promoção sem sabor definido — o do dia depende do estoque.
  { name: 'Beats', group: 'Beats', kind: 'drink', alias: 'sem sabor sortido' },
  { name: 'Beats Senses', group: 'Beats', kind: 'drink' },
  { name: 'Beats GT', group: 'Beats', kind: 'drink' },
  { name: 'Beats Redmix', group: 'Beats', kind: 'drink', alias: 'red mix' },
  { name: 'Beats Tropical', group: 'Beats', kind: 'drink' },
  { name: 'Beats Green Mix', group: 'Beats', kind: 'drink' },

  // Doses
  { name: 'Gin Nacional', group: 'Doses', kind: 'drink', alias: 'dose' },
  { name: 'Gin Importado', group: 'Doses', kind: 'drink', alias: 'dose' },
  { name: 'Vodka Nacional', group: 'Doses', kind: 'drink', alias: 'dose' },
  { name: 'Vodka Importado', group: 'Doses', kind: 'drink', alias: 'dose' },
  { name: 'Whisky Nacional', group: 'Doses', kind: 'drink', alias: 'dose uisque' },
  { name: 'Whisky Importado', group: 'Doses', kind: 'drink', alias: 'dose uisque' },

  // Shots
  { name: 'Bananazinha', group: 'Shots', kind: 'drink', alias: 'shot' },
  { name: 'Tequila', group: 'Shots', kind: 'drink', alias: 'shot' },
  { name: 'Jambuzada', group: 'Shots', kind: 'drink', alias: 'shot jambu' },

  // Drinks
  { name: 'Caipirinha Limão', group: 'Drinks', kind: 'drink', alias: 'caipira' },
  { name: 'Caipirinha Frutas', group: 'Drinks', kind: 'drink', alias: 'caipira' },
  { name: 'Caipivodka Limão', group: 'Drinks', kind: 'drink', alias: 'caipira' },
  { name: 'Caipivodka Frutas', group: 'Drinks', kind: 'drink', alias: 'caipira' },
  { name: 'Bramble', group: 'Drinks', kind: 'drink' },
  { name: 'Moscow Mule', group: 'Drinks', kind: 'drink' },
  { name: 'Lagoa Azul', group: 'Drinks', kind: 'drink', alias: 'blue' },
  { name: 'Mojito', group: 'Drinks', kind: 'drink' },
  { name: 'Sex on the Beach', group: 'Drinks', kind: 'drink' },
  { name: 'Pink Lemonade', group: 'Drinks', kind: 'drink' },
  { name: 'Gin Tropical', group: 'Drinks', kind: 'drink' },
  { name: 'Gin Melancia', group: 'Drinks', kind: 'drink' },
  { name: 'Gin Tônica', group: 'Drinks', kind: 'drink' },

  // Soft drinks
  { name: 'Água sem Gás', group: 'Soft Drinks', kind: 'drink' },
  { name: 'Água com Gás', group: 'Soft Drinks', kind: 'drink' },
  { name: 'Refrigerante Lata', group: 'Soft Drinks', kind: 'drink', alias: 'coca guarana' },
  { name: 'Red Bull', group: 'Soft Drinks', kind: 'drink', alias: 'energetico' },
  { name: 'Tônica', group: 'Soft Drinks', kind: 'drink' },
  { name: 'H2OH', group: 'Soft Drinks', kind: 'drink' },
  { name: 'Suco', group: 'Soft Drinks', kind: 'drink' },

  // Burger's
  { name: 'Galeria Burger', group: "Burger's", kind: 'food', alias: 'hamburguer' },
  { name: 'Galeria Eggs & Bacon', group: "Burger's", kind: 'food', alias: 'hamburguer eggsbacon' },
  { name: 'Galeria Calabresa', group: "Burger's", kind: 'food', alias: 'hamburguer' },
  { name: 'Galeria Salada', group: "Burger's", kind: 'food', alias: 'hamburguer' },
  { name: 'Galeria Onion', group: "Burger's", kind: 'food', alias: 'hamburguer' },
  { name: 'Mini Burgers', group: "Burger's", kind: 'food', alias: 'hamburguer sliders' },

  // Petiscos
  { name: 'Fritas Tradicional', group: 'Petiscos', kind: 'food', alias: 'batata' },
  { name: 'Fritas Cheddar e Bacon', group: 'Petiscos', kind: 'food', alias: 'batata' },
  { name: 'Onion Rings', group: 'Petiscos', kind: 'food', alias: 'cebola' },
  { name: 'Carne e Fritas', group: 'Petiscos', kind: 'food', alias: 'batata' },
  { name: 'Porção de Mini Pastéis', group: 'Petiscos', kind: 'food', alias: 'pastel' },
  { name: 'Linguiça e Fritas', group: 'Petiscos', kind: 'food', alias: 'batata' },
  { name: 'Frango a Passarinho', group: 'Petiscos', kind: 'food' },
];

/** minúsculas, sem acento — base das comparações de busca. */
export function normalizeTerm(raw: string): string {
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

const HAYSTACK = new Map<MenuItem, string>(
  MENU_ITEMS.map((it) => [it, normalizeTerm(`${it.name} ${it.group} ${it.alias ?? ''}`)]),
);

/** Mínimo de letras pra abrir a lista (mesma regra do autocomplete de DJs). */
export const MENU_SEARCH_MIN = 3;

/**
 * Busca por substring em nome + grupo + apelidos, ignorando acento e espaço
 * ("longneck" acha "Budweiser Long Neck"). Prioriza quem começa com o termo.
 * `kind` filtra a categoria da seção; se nada bater, cai pro catálogo inteiro.
 */
export function searchMenuItems(query: string, kind?: MenuKind, limit = 8): MenuItem[] {
  const needle = normalizeTerm(query);
  if (needle.length < MENU_SEARCH_MIN) return [];
  const tight = needle.replace(/\s+/g, '');

  const match = (it: MenuItem) => {
    const hay = HAYSTACK.get(it) ?? '';
    return hay.includes(needle) || hay.replace(/\s+/g, '').includes(tight);
  };

  const scoped = kind ? MENU_ITEMS.filter((it) => it.kind === kind) : MENU_ITEMS;
  let hits = scoped.filter(match);
  if (hits.length === 0 && kind) hits = MENU_ITEMS.filter((it) => it.kind !== kind && match(it));

  return hits
    .sort((a, b) => {
      const aStarts = normalizeTerm(a.name).startsWith(needle) ? 0 : 1;
      const bStarts = normalizeTerm(b.name).startsWith(needle) ? 0 : 1;
      if (aStarts !== bStarts) return aStarts - bStarts;
      return a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' });
    })
    .slice(0, limit);
}

/**
 * Palavras que denunciam comida mesmo quando o item não está no catálogo
 * (grafias livres tipo "MINI BURGUERS", "GALERIA EGGSBACON", "BATATA G").
 */
const FOOD_KEYWORDS = [
  'fritas',
  'batata',
  'burger',
  'burguer',
  'hamburguer',
  'onion',
  'cebola',
  'pastel',
  'pasteis',
  'linguica',
  'carne',
  'frango',
  'petisco',
  'porcao',
  'eggs',
  'bacon',
  'cheddar',
  'calabresa',
  'salada',
  'isca',
  'nuggets',
];

const TOKEN_MIN = 3;

function tokensOf(s: string): string[] {
  return s.split(/[^a-z0-9]+/).filter((t) => t.length >= TOKEN_MIN);
}

const TOKENS = new Map<MenuItem, string[]>(
  MENU_ITEMS.map((it) => [it, tokensOf(normalizeTerm(`${it.name} ${it.group} ${it.alias ?? ''}`))]),
);

/** Quantos tokens do texto aparecem no item (comparação frouxa nos dois sentidos). */
function tokenScore(needleTokens: string[], itemTokens: string[]): number {
  return needleTokens.filter((t) =>
    itemTokens.some((it) => it === t || it.includes(t) || t.includes(it)),
  ).length;
}

/**
 * Descobre se um nome escrito à mão é comida ou bebida. Usado pra distribuir
 * uma lista colada nas categorias de promoção e pelo parse de texto legado.
 * Ordem: nome exato → nome contido → sobreposição de tokens (nome+grupo+apelidos)
 * → palavras-chave de comida. Empate ou nada reconhecido devolve `null`.
 */
export function menuKindOf(name: string): MenuKind | null {
  const needle = normalizeTerm(name);
  if (!needle) return null;

  const exact = MENU_ITEMS.find((it) => normalizeTerm(it.name) === needle);
  if (exact) return exact.kind;

  const partial = MENU_ITEMS.find(
    (it) => needle.includes(normalizeTerm(it.name)) || normalizeTerm(it.name).includes(needle),
  );
  if (partial) return partial.kind;

  const needleTokens = tokensOf(needle);
  if (needleTokens.length > 0) {
    let food = 0;
    let drink = 0;
    for (const it of MENU_ITEMS) {
      const score = tokenScore(needleTokens, TOKENS.get(it) ?? []);
      if (it.kind === 'food') food = Math.max(food, score);
      else drink = Math.max(drink, score);
    }
    if (food > drink) return 'food';
    if (drink > food) return 'drink';
  }

  if (FOOD_KEYWORDS.some((k) => needle.includes(k))) return 'food';
  return null;
}
